/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { Card, Typography } from '@material-ui/core';
import moment from 'moment';
import evaluoServices from '../../../../redux/services/evaluoServices';
import UpdateEvaluoExam from './UpdateEvaluoExam';
import useEvaluoExam from './useEvaluoExam';
import { Loading } from '../../../../helpers/utils';
import AddStudent from './AddStudent';

const ListEvaluoExam = ({
  company,
  semestersList,
  refresh,
  setRefresh,
  loadingList,
  setLoadingList,
  allSubjects,
}) => {
  const [evaluoExams, setEvaluoExams] = useState([]);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openAddStudentModal, setOpenAddStudentModal] = useState(false);
  const [selectedExamData, setSelectedExamData] = useState({});

  const { deleteEvaluoExam } = useEvaluoExam(company, refresh, setRefresh);

  const getData = async () => {
    const res = await evaluoServices.getEvaluoExamsByCompany(company._id);
    if (res && !res.error) {
      setEvaluoExams(res);
      setLoadingList(false);
    } else {
      setEvaluoExams([]);
      setLoadingList(false);
    }
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  return (
    <Card style={{ marginTop: '20px', marginBottom: '20px' }}>
      {loadingList === false
        ? (
          <div>
            <MaterialTable
              title="Examens Evaluo"
              data={evaluoExams}
              columns={[
                {
                  title: 'Nom',
                  field: 'name',
                  render: ({ name }) => (
                    <Typography variant="body2">{name}</Typography>
                  ),
                },
                {
                  title: 'Début',
                  field: 'temporality.start_at',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{moment(new Date(temporality.start_at)).format('DD/MM/YYYY à HH:mm')}</Typography>
                  ),
                },
                {
                  title: 'Fin',
                  field: 'temporality.end_at',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{moment(new Date(temporality.end_at)).format('DD/MM/YYYY à HH:mm')}</Typography>
                  ),
                },
                {
                  title: 'Durée',
                  field: 'temporality.duration',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{temporality.duration}</Typography>
                  ),
                },
              ]}
              actions={[
                {
                  icon: 'add',
                  tooltip: 'Ajouter étudiant(e)',
                  onClick: (event, rowData) => {
                    setSelectedExamData(rowData);
                    setOpenAddStudentModal(true);
                  },
                },
                {
                  icon: 'edit',
                  tooltip: 'Mettre à jour',
                  onClick: (event, rowData) => {
                    setSelectedExamData(rowData);
                    setOpenUpdateModal(true);
                  },
                },
                {
                  icon: 'delete',
                  tooltip: 'Supprimer',
                  onClick: (event, rowData) => {
                    setLoadingList(true);
                    deleteEvaluoExam(rowData.id);
                  },
                },
              ]}
              options={{
                pageSize: 5,
                pageSizeOptions: [5, 20, 50],
              }}
            />
            <UpdateEvaluoExam
              open={openUpdateModal}
              setOpen={setOpenUpdateModal}
              examData={selectedExamData}
              semestersList={semestersList}
              setLoadingList={setLoadingList}
              setRefresh={setRefresh}
              refresh={refresh}
              allSubjects={allSubjects}
            />
            <AddStudent
              examData={selectedExamData}
              open={openAddStudentModal}
              setOpen={setOpenAddStudentModal}
              company={company}
            />
          </div>
        )
        : (
          <div
            style={{
              marginTop: '50px',
              marginBottom: '50px',
            }}
          >
            <Loading />
          </div>
        )}
    </Card>
  );
};

ListEvaluoExam.propTypes = {
  company: PropTypes.object.isRequired,
};

export default ListEvaluoExam;
